import React, {useState} from "react";
import  "./newsLetter.css";
import NewsLetterForm from "./newsLetterForm";

const NewsLetter = React.memo(props => {
    let mailTo = props.mailTo;
    return (
    <React.Fragment>
        <div className="container">
            <div className="NewsLetterCont">
                <div className="dvRegistrTopTitle">שמרו על קשר</div>
                <div className="dvRegistr">הרשמו למערכת הדיוור הישיר</div>
                <NewsLetterForm siteUrl={props.siteUrl} mailTo={mailTo} lang={props.lang} museumsDropDown={props.museumsDropDown}/>
            </div>
            <div className="dvNewsLetter">
                <h3></h3>
            </div>
        </div>
    </React.Fragment>
    );
});

export default NewsLetter;